export enum NoteType {
  NORMAL = "NORMAL",
  PACKAGING_INSTRUCTION = "PACKAGING_INSTRUCTION",
  PACKAGING_DIMENSIONS = "PACKAGING_DIMENSIONS",
  LATE_SHIPPING_QUALIFICATION = "LATE_SHIPPING_QUALIFICATION",
}
